export const cycleCreatorPlaceholder = '{{creator_email}}';
